import Select from 'react-select';
import Accordion from 'react-bootstrap/Accordion';
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { DropDownList, ComboBox } from "@progress/kendo-react-dropdowns";
import { useState,useEffect } from 'react'
import { SBAComboBox } from '../../UiComponents/SBADropDown';

export const ExpandCollapseAccordionGeneral = ({ GeneralData, setTabData, tabData, saveData }) => {
    const { AuditorDetails, IssuingOffice, AuditorId, IssueDate, OpinionId, AccountingStandardId, CurrencyId, IssuingOfficeId, OwnershipInMF, IsCFTC, IsMasterFeeder } = GeneralData;
    const AccountingStandardLocal = [{ AcountingStandardDesc: "--select--", AccountingStandardId: 0 }, { AcountingStandardDesc: "GAAP", AccountingStandardId: 1 }, { AcountingStandardDesc: "IFRS", AccountingStandardId: 2 }];
    const OpinionLocal = [{ OpinionDesc: "--select--", OpinionId: 0 }, { OpinionDesc: "Qualified Opinion", OpinionId: 2 }, { OpinionDesc: "Unqualified Opinion", OpinionId: 1 }];
    const Currency = [{ label: "--select--", value: 0 }, { label: "US Dollar", value: 1 }, { label: "British Pound", value: 3 }, { label: "Canadian Dollar", value: 4 }, { label: "Euro", value: 2 },{ label: "Norwegian Krone", value: 6 }, { label: "Swiss franc", value: 5 }];
    const defaultCurrency = CurrencyId == -1 || CurrencyId==0
        ? Currency.find(item => item.label === "US Dollar")
        : Currency.find(item => item.value === CurrencyId);

    const [auditor, setAuditor] = useState(AuditorDetails.filter(item => item.FinancialStatementAuditorId === AuditorId)[0]);
    const [opinion, setOpinion] = useState(OpinionLocal.filter(item=>item.OpinionId===OpinionId)[0]);
    const [accountingStandard, setAccountingStandard] = useState(AccountingStandardLocal.filter(item=>item.AccountingStandardId===AccountingStandardId)[0]);
    const [issuingOffice, setIssuingOffice] = useState(IssuingOffice.filter(item=>item.FinancialStatementIssuingOfficeId===IssuingOfficeId)[0]);
    const [currency, setCurrency] = useState(defaultCurrency);
    const [ownershipInMF, setOwnershipInMF] = useState(OwnershipInMF);
    const [isCFTC, setIsCFTC] = useState(IsCFTC);
    const [isMasterFeeder, setIsMasterFeeder] = useState(IsMasterFeeder);
    const IssuedDate=IssueDate==="0001-01-01T00:00:00"?new Date():new Date(IssueDate);
    const [issueDate,setIssueDate]=useState(IssuedDate);

    useEffect(() => {
        setTabData({...saveData,IssueDate:IssuedDate,CurrencyId:CurrencyId==-1 || CurrencyId==0 ? 1: CurrencyId});
    }, []);


    const AuditorsDropdownChanged = (e) => {
        setAuditor(e.value);
        setTabData({...saveData, AuditorId:e.value.FinancialStatementAuditorId});
    }
    const OpinionDropdownChanged = (e) => {
        setOpinion(e.value);
        setTabData({...saveData, OpinionId:e.value.OpinionId});
    }
    const AccountingStandardDropdownChanged = (e) => {
        setAccountingStandard(e.value);
        setTabData({...saveData,AccountingStandardId:e.value.AccountingStandardId});
    }
    const IssuingOfficeDropdownChanged = (e) => {
        setIssuingOffice(e.value);
        setTabData({...saveData,IssuingOfficeId:e.value.FinancialStatementIssuingOfficeId});
    }
    const CurrencyDropdownChanged = (e) => {
        setCurrency(e.value);
        setTabData({...saveData, CurrencyId:e.value.value});
    }

    const IsMasterFeederHandler = (e) => {
        setIsMasterFeeder(e.target.checked);
        setTabData({...saveData,IsMasterFeeder:e.target.checked});
    }

    const IsCFTCHandler = (e) => {
        setIsCFTC(e.target.checked);
        setTabData({...saveData,IsCFTC:e.target.checked});
    }
    const IssueDateChange=(e)=>{
        setIssueDate(e.value);
        setTabData({...saveData,IssueDate:e?.value?.toISOString() || null})
    }
    const ownerShipTBKU=(e)=>{
        const newOnwerValue=parseInt(e.target.value);
        let value=newOnwerValue;
        if(newOnwerValue>100)
        {
            e.target.value=100;
            value=100;
        }
        setTabData({...saveData,OwnershipInMF:value});

    }
    return <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0" >
            <Accordion.Header>General</Accordion.Header>
            <Accordion.Body>
                <div class="col-lg-12 px-0">
                    <div className="row detail m-0 p-2">
                        <div className="col-md-3">
                            <div className="mb-4">
                                <span className="darkLabel">Auditor <span className="mandatory">*</span></span>
                                <p className="fw-medium mb-0">
                                    {/* <ComboBox data={AuditorDetails}
                                        textField="AuditorName"
                                        dataItemKey="FinancialStatementAuditorId"
                                        onChange={AuditorsDropdownChanged}
                                        value={selAuditorName}
                                        className="basic-single"
                                        clearButton={false}
                                    /> */}
                                    <SBAComboBox
                                        data={AuditorDetails}
                                        textField="AuditorName"
                                        dataItemKey="FinancialStatementAuditorId"
                                        onChange={AuditorsDropdownChanged}
                                        value={auditor}
                                        className="basic-single"
                                        clearButton={false}
                                        filterable={true}
                                    />
                                </p>
                            </div>

                            <div className="mb-4">
                                <span class="darkLabel">Opinion </span>
                                <p className="fw-medium mb-0">
                                    <SBAComboBox
                                        data={OpinionLocal}
                                        textField="OpinionDesc"
                                        dataItemKey="OpinionId"
                                        onChange={OpinionDropdownChanged}
                                        value={opinion}
                                        className="basic-single"
                                        clearButton={false}

                                    />
                                </p>
                            </div>

                            <div className="mb-4">
                                <span class="darkLabel">Ownership in MF </span>
                                <p className="fw-medium mb-0">
                                    <input type='number' id='txtOwnwershipInMF' defaultValue={ownershipInMF} className="form-control" style={{ width: "70px", float: "left" }} onKeyUp={ownerShipTBKU} />
                                    <label htmlFor='txtOwnwershipInMF' style={{ marginLeft: "10px" }} className='darkLabel'>%</label>
                                </p>
                            </div>



                        </div>
                        <div className="col-md-3">


                            <div className="mb-4">
                                <span class="darkLabel">Currency <span className="mandatory">*</span> </span>
                                <p className="fw-medium mb-0">
                                    <SBAComboBox
                                         data={Currency}
                                        textField="label"
                                        dataItemKey="value"
                                        onChange={CurrencyDropdownChanged}
                                        filterable={true}
                                        value={currency}
                                        className="basic-single"
                                        clearButton={false}
                                    />
                                </p>
                            </div>


                            <div className="mb-4">
                                <span class="darkLabel">Issue Date  <span className="mandatory">*</span></span>
                                <p className="fw-medium mb-0">
                                    <DatePicker defaultValue={new Date(issueDate)} format="MM/dd/yyyy" weekNumber={true} style={{ height: "33px" }} onChange={(e)=>{IssueDateChange(e)}}></DatePicker>
                                </p>
                            </div>


                            <div className="mb-4">
                                <p >
                                    <label style={{ display: "flex", alignItems: "center" }}>
                                        <input type='checkbox' className='me-1' id='txtMasterFeeder' checked={isMasterFeeder} onChange={IsMasterFeederHandler} ></input>
                                        <span style={{ marginLeft: "10px" }} class="darkLabel">Master Feeder</span>
                                    </label>
                                </p>
                            </div>


                        </div>
                        <div className="col-md-3">
                            <div className="mb-4">
                                <span class="darkLabel">Issuing Office <span className="mandatory">*</span> </span>
                                <p className="fw-medium mb-0">
                                    <SBAComboBox data={IssuingOffice}
                                        textField="OfficeName"
                                        dataItemKey="FinancialStatementIssuingOfficeId"
                                        onChange={IssuingOfficeDropdownChanged}
                                        filterable={true}
                                        value={issuingOffice}
                                        className="basic-single"
                                        clearButton={false}
                                    />
                                </p>
                            </div>

                            <div className="mb-4">
                                <span class="darkLabel">Accounting Standard  <span className="mandatory">*</span></span>
                                <p className="fw-medium mb-0">
                                    <SBAComboBox
                                        data={AccountingStandardLocal}
                                        textField="AcountingStandardDesc"
                                        dataItemKey="AccountingStandardId"
                                        onChange={AccountingStandardDropdownChanged}
                                        filterable={true}
                                        value={accountingStandard}
                                        className="basic-single"
                                        clearButton={false}
                                    />
                                </p>
                            </div>

                            <div className="mb-4">
                                <p >
                                    <label style={{ display: "flex", alignItems: "center" }}>
                                        <input type='checkbox' className='me-1' id='txtCFTC' checked={isCFTC} onChange={IsCFTCHandler}></input>
                                        <span style={{ marginLeft: "10px" }} class="darkLabel">CFTC</span>
                                    </label>
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </Accordion.Body>
        </Accordion.Item>
    </Accordion>
}